// src/stores/Factors.js
import { ref } from "vue";
import { defineStore } from "pinia";
import apiClient from "@/axios";
import { useToast } from "vue-toastification";
import { useConfirm } from "../composables";

export const useUsersStore = defineStore("users", () => {
    const userList = ref([]);
    const loading = ref(false);
    const pagination = ref({ total: 0, current_page: 1, per_page: 20 });
    const searchQuery = ref("");
    const toast = useToast();

    async function fetchUsers(page = 1) {
        loading.value = true;

        try {
            const requestBody = {
                filters: [], // اضافه کردن فیلترهای دلخواه
                page: page,
                perPage: pagination.value.per_page,
                searchColumn: ["UserName", "FirstName", "LastName", "MobileNumber", "PhoneNumber"],
                search: searchQuery.value,
                orderBy: "UserName DESC"
            };
            const response = await apiClient.post('/User/GetAllUserClinicAsync', requestBody);
            console.log(response.data.result);
            userList.value = Array.isArray(response.data?.result) ? [...response.data.result] : [];

            pagination.value = {
                total: response.data?.totalCount ?? pagination.value.total,
                current_page: response.data?.currentPage ?? page,
                per_page: response.data?.perPage ?? pagination.value.per_page
            };

            return response.data.result;
        } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
        } finally {
            loading.value = false;
        }
    }
    async function addUser(userData) {
        loading.value = true;
        try {
            const response = await apiClient.post('User/RegisterUserClinic', userData);

            if (response.status === 200) {
                toast.success("کاربر با موفقیت ثبت شد");
                searchQuery.value = "";
                await fetchUsers(1); // جدول را بلافاصله بروزرسانی کن
            } else {
                toast.error("خطا در ثبت اطلاعات کاربر");
                console.error(response.data);
            }
        } catch (error) {
            console.error("Error adding user:", error);
            toast.error("خطا در ثبت اطلاعات کاربر");
        } finally {
            loading.value = false;
        }
    }

    async function updateUser(input) {
        loading.value = true;
        try {
            const response = await apiClient.post('User/RegisterUserClinic', input);
            if (response.status === 200) {
                toast.success("اطلاعات کاربر با موفقیت ویرایش شد");
                await fetchUsers(pagination.value.current_page); // جدول را بروزرسانی کن
            } else {
                toast.error("خطا در ویرایش اطلاعات کاربر");
                console.error(response.data);
            }
        } catch (error) {
            console.error("Error updating user:", error);
            toast.error("خطا در ویرایش اطلاعات کاربر");
        } finally {
            loading.value = false;
        }
    }
    async function deleteUser(id) {
        loading.value = true;
        try {
            const response = await apiClient.delete(`/User/${id}`);

            if (response.status === 200) {
                toast.success("کاربر با موفقیت حذف شد");
                await fetchUsers(pagination.value.current_page);
            } else {
                toast.error("خطا در حذف کاربر");
                console.error(response.data);
            }
        } catch (error) {
            console.error("Error deleting user:", error);
            toast.error("خطا در حذف کاربر");
        } finally {
            loading.value = false;
        }
    }

    return {
        userList,
        fetchUsers,
        addUser,
        updateUser,
        deleteUser,
        loading,
        pagination,
        searchQuery
    }
})